export default __webpack_public_path__ + "static/media/patients_mobile.a767254f.png";